import ArrowDown from '@sats-group/icons/24/arrow-down';
import ArrowRight from '@sats-group/icons/24/arrow-right';
import ArrowUp from '@sats-group/icons/24/arrow-up';
import Collapse from '@sats-group/ui-lib/react/collapse/collapse';
import Text from '@sats-group/ui-lib/react/text';
import React, { useState } from 'react';
import type { SitemapNode as Props } from './sitemap-node.types';

const ListElement: React.FunctionComponent<
  React.PropsWithChildren<{ header: React.ReactNode }>
> = ({ children, header }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div>
      <div className="web-admin-sitemap__node-header">
        {children ? (
          <button
            className="web-admin-sitemap__node-indicator web-admin-sitemap__node-indicator--toggler"
            onClick={() => setIsExpanded(a => !a)}
          >
            {isExpanded ? <ArrowUp /> : <ArrowDown />}
          </button>
        ) : (
          <div className="web-admin-sitemap__node-indicator">
            <ArrowRight />
          </div>
        )}
        <Text onClick={() => setIsExpanded(a => !a)} size={Text.sizes.basic}>
          {header}
        </Text>
      </div>

      {children ? (
        <Collapse isOpen={isExpanded}>
          <div className="web-admin-sitemap__node-content">{children}</div>
        </Collapse>
      ) : null}
    </div>
  );
};

const SitemapNode: React.FunctionComponent<Props> = ({
  data = {},
  parentUrl = '',
}) => (
  <div className="web-admin-sitemap__node">
    {Object.entries(data)
      .sort((a, b) => a[0].localeCompare(b[0]))
      .map(([slug, children]) => {
        const url = [parentUrl, slug].join('/');

        const link =
          typeof children === 'object' && children['/'] ? (
            //biome-ignore lint/correctness/useJsxKeyInIterable: ListElement has key
            <a href={url}>{slug}</a>
          ) : typeof children === 'boolean' && slug !== '/' ? (
            //biome-ignore lint/correctness/useJsxKeyInIterable: ListElement has key
            <a href={url}>{slug}</a>
          ) : slug !== '/' ? (
            slug
          ) : null;

        const childNodes =
          typeof children === 'object' ? (
            <SitemapNode data={children} parentUrl={url} key={url} />
          ) : null;

        return link || childNodes ? (
          <ListElement header={link} key={url}>
            {childNodes}
          </ListElement>
        ) : null;
      })}
  </div>
);

export default SitemapNode;
